export interface MaterialInventoryItem {
    id?: number; // Optional, as it may not be set during creation
    material_size_id: number | null; // Now uses ID instead of string (null for uninitialized state)
    material_type_id: number | null; // Now uses ID instead of string (null for uninitialized state)
    color_name: string; // Required name of the color (e.g., "Black")
    color_code: string; // Required unique identifier for the color
    quantity: number; // Required quantity of the material
    quantity_unit: string; // Required unit of measurement for the quantity (e.g., "meters", "pieces")
    material_description: string; // Required material composition (e.g., "Nylon", "Steel")
    average_price_per_unit: number; // Required average price per unit of measurement
}

export interface UpdateMaterialInventoryPayload {
    material_type_id: number | null; // Required ID of the material type
    material_size_id: number | null; // Required ID of the material size
    color_code: string; // Required unique identifier for the color
    quantity_changed?: number; // Optional quantity changed, required if adding a new quantity
    remaining_quantity?: number; // Optional remaining quantity, required if updating remaining stock
    quantity_unit?: string; // Optional unit of measurement for the quantity (e.g., "meters", "pieces")
    quantity_type?: string; // Optional type of quantity
}

export interface InventoryRecord {
    id: number;
    material_type_id: number; // Type of the material
    material_size_id: number; // Size of the material
    user_id: number; // Associated user ID
    color_name: string; // Name of the color (e.g., "Black")
    color_code: string; // Unique identifier for the color
    quantity: number; // Quantity of the material
    quantity_unit: string; // Unit of measurement (e.g., "meters", "pieces")
    material_description: string; // Material composition (e.g., "Nylon", "Steel")
    average_price_per_unit: number; // Average price per unit
    balance: number; // Remaining balance of the material
    created_at?: Date; // Optional: Creation timestamp
    updated_at?: Date; // Optional: Last updated timestamp
    material_type: string; // Name/type of the material
    material_size: string;
}

export const defaultUpdateInventoryItem: UpdateMaterialInventoryPayload = {
    material_type_id: 0,
    material_size_id: 0,
    color_code: "",
    quantity_changed: 0,
    quantity_unit: "",
};